/* eslint-disable import/prefer-default-export */
export class TarjetasOroConstants {
  static CUATRO_POR_CIENTO = '4%' as string;

  static SEIS_POR_CIENTO = '6%' as string;

  static CUOTA_BAJA = 4.99 as number;

  static CUOTA_ALTA = 12.99 as number;

  static ID_ESPAÑA_STR = 'es' as string;

  static FORM_ORO = 'form-oro';

  static FORM_GASTO = 'form-gasto';

  static TIPO_CUOTA_4_STRING = '102';

  static TIPO_CUOTA_6_STRING = '101';

  static TIPO_CUOTA_4 = 102;

  static TIPO_CUOTA_6 = 101;

  static TIPO_USUARIO_ORO_CON_PASAPORTE = 2;
}
